import Repository from "./Repository";

const CREATE = "add";
const GET = "get";
const UPDATE = "edit";
const DELETE = "delete";

export default {
  createMedicalCancer(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  getMedicalCancer(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
  updateMedicalCancer(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },
  deleteMedicalCancer(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
};

const transformRoute = (route) => {
  return `/medical_cancer/${route}`;
};
